import { Dispatch, SetStateAction, createContext } from 'react';

interface ModalContext {
    activeModalId: string | null;
    setActiveModalId: Dispatch<SetStateAction<string | null>>;
    portalTargetId: string;
}

export default createContext<ModalContext>({} as ModalContext);
